var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"earth3dRef",staticClass:"earth-3d",attrs:{"id":"earth3dRef"}})
}
var staticRenderFns = []

export { render, staticRenderFns }